<template>
  <b-modal
    v-model="isModalVisible"
    id="takePhoto"
    size="md"
    centered
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
  >
    <video
      ref="camera"
      width="100%"
      height="325"
      autoplay
      style="background-color: #000"
    ></video>

    <canvas class="canvas" ref="canvas" :width="325" :height="250"></canvas>

    <b-row class="mt-3">
      <b-col cols="12" class="tw-p-0">
        <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
          <BaseButton
            color="secondary"
            size="lg"
            @click="capture"
            class="tw-w-full tw-basis-0 tw-flex-1"
          >
            Capture
          </BaseButton>

          <BaseButton
            @click="isModalVisible = false"
            color="posey-green"
            class="tw-w-full tw-basis-0 tw-flex-1"
            outline
            size="lg"
          >
            Cancel
          </BaseButton>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, Boolean],
      required: true,
    },
  },
  computed: {
    isModalVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    isModalVisible: {
      handler(isVisible) {
        if (!isVisible) {
          this.stopCameraStream();
          this.$emit("close");
        } else {
          this.createCameraElement();
          this.$emit("open");
        }
      },
      immediate: true,
    },
  },
  methods: {
    capture() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      context.drawImage(this.$refs.camera, 0, 0, 325, 250);

      const dataUrl = canvas.toDataURL("image/png");

      this.$emit("capture", dataUrl);
      this.isModalVisible = false;
    },
    async createCameraElement() {
      try {
        const constraints = (window.constraints = {
          audio: false,
          video: {
            facingMode: "user",
          },
        });

        const stream = await navigator.mediaDevices.getUserMedia(constraints);

        this.$refs.camera.srcObject = stream;
      } catch (error) {
        if (error.name == "NotAllowedError") {
          this.isModalVisible = false;

          this.$emit(
            "showAlert",
            "Camera is not detected. Please turn on your camera and refresh your browser."
          );

          alert(
            "Camera is not detected. Please turn on your camera and refresh your browser."
          );
        }

        console.log(error);
      }
    },
    stopCameraStream() {
      if (!this.$refs.camera?.srcObject) {
        return;
      }

      const tracks = this.$refs.camera.srcObject.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas {
  position: absolute;
  left: -9999px;
}
</style>
